/* this file is transformed by vux-loader */
/* eslint-disable */
export default {
  name: 'JumpBlock',
  props: {
    routeName: {
      type: String
    },
    opts: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    auth: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: 'div'
    },
    title: {
      type: String,
      default: ''
    }
  },
  render: function render(h) {
    var _this = this;

    return h(this.tag, {
      class: {
        'main-color': this.auth
      },
      on: {
        click: function click(e) {
          if (_this.auth) {
            _this.$router.push({
              name: _this.routeName,
              params: _this.opts
            });

            e.stopPropagation();
          }
        }
      }
    }, this.title ? this.title : this.$slots.default);
  }
};